import { render, staticRenderFns } from "./CardAdminLideres.vue?vue&type=template&id=e8240df4&scoped=true"
import script from "./CardAdminLideres.vue?vue&type=script&lang=js"
export * from "./CardAdminLideres.vue?vue&type=script&lang=js"
import style0 from "./CardAdminLideres.vue?vue&type=style&index=0&id=e8240df4&prod&scoped=true&lang=css"
import style1 from "../../assets/styles/personal-admin.css?vue&type=style&index=1&id=e8240df4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8240df4",
  null
  
)

export default component.exports